import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux'
import authReducer from './auth.ts';
import groupListReducer from './groupList';
import groupReducer from './group';
import uploadsReducer from './upload';
import uiReducer from './ui';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        groupList: groupListReducer,
        group: groupReducer,
        uploads: uploadsReducer,
        ui: uiReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    })
})

// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store

// Use instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()